class social {
	constructor() {
		
	}
	share(el) {
		const intent = el.getAttribute('data-intent');
		const pageTitle = el.getAttribute('data-page-title');
		const message = `${pageTitle} ${window.location.href}`;
		switch (intent) {
			case "tweet":
				this.tweet(message, window.location.href);
				break;
			case "facebook":
				break;
			default:
				throw new Error('Intent not supported.');
				break;
		}
	}
	tweet(message, url) {
		
	}
}
window.app.add('social', new social());